import type { FC, ReactNode } from 'react';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg';
  disableClose?: boolean;
  hideClose?: boolean;
}

const maxWidthClass = {
  sm: 'max-w-sm',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
};

export const Dialog: FC<DialogProps> = ({
  open,
  onClose,
  title,
  children,
  footer,
  maxWidth = 'md',
  disableClose,
  hideClose,
}) => {
  if (!open) return null;

  const preventClose = disableClose || hideClose;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={preventClose ? undefined : onClose} />
      <div className={`relative bg-background border border-border rounded-lg shadow-lg w-full ${maxWidthClass[maxWidth]} mx-2 sm:mx-4 mb-16 max-h-[80vh] flex flex-col overflow-hidden`}>
        <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-border shrink-0">
          <h2 className="text-lg font-semibold">{title}</h2>
          {!hideClose && (
            <button
              onClick={onClose}
              disabled={disableClose}
              className="text-muted-foreground hover:text-foreground text-xl leading-none disabled:opacity-50"
            >
              &times;
            </button>
          )}
        </div>
        <div className="overflow-y-auto min-h-0">
          {children}
        </div>
        {footer && (
          <div className="shrink-0 border-t border-border px-4 sm:px-6 py-4">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};
